<template>
    <b-carousel-list v-if="okcarousel" :data="items" :items-to-show="toshow">
        <template slot="item" slot-scope="props">
            <p v-if="toshow==1"><small>glisser vers la gauche pour faire defiler</small></p>
            <div class="card">
                <div class="card-image">
                    <figure class="image is-3by2">
                        <img alt="img" :src="props.list.image.path" @error="imageUrlAlt">
                    </figure>
                </div>
                <div class="card-content" id="carouselactus">
                    <div class="content">
                        <p class="title is-6">{{ props.list.title }}</p>
                        <p class="subtitle is-6 coco" v-if="props.list.excerpt" v-html="props.list.excerpt"></p>
                        <p class="subtitle is-6 coco" v-else v-html="props.list.content"></p>
                        <div class="field is-grouped">
                            <p class="control subtitle is-7" v-if="props.list.datepost">
                                <span title="publié le" class="has-text-grey">
                                    <b-icon icon="clock-outline">
                                    </b-icon> {{props.list.datepost | formatDate}}
                                </span>
                            </p>
                            <p class="control" style="margin-left: auto">
                                <router-link v-if="props.list.excerpt" class="button is-small is-info is-outlined" :to="'/post/'+ props.list._id+'#voir'">Voir plus</router-link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </b-carousel-list>
</template>
<script>
    const axios = require('axios');
    export default {
    data() {
        return {
            toshow: window.innerWidth < 640 ? 1 : 3,
            loading: true,
            items: null,
            error: null,
            limitperpage: 10,
            curr_path: window.location.origin,
            okcarousel:false,
        }
    },
    created() {
        this.fetchData()
    },
    methods: {
        imageUrlAlt(event) {
            event.target.src = "https://buefy.org/static/img/placeholder-1280x960.png"
        },
        fetchData() {
            this.error = this.items = null
            this.loading = true
            var vm = this
            var fetchurl = this.$api_url_posts+'&sort[datepost]=-1'
            axios({
                    method: 'get',
                    url: fetchurl
                    /*method: 'post',
                    url: fetchurl,
                    headers: { 'Content-Type': 'application/json' },
                    data: JSON.stringify({
                        sort: { datepost: -1 },
                    })*/
                })
                .then(function(response) {
                    vm.loading = false
                    vm.items = response.data.entries.slice(0, vm.limitperpage)
                    vm.okcarousel = true
                })
                .catch(function() {
                    vm.error = 'erreur'
                })
        },
    },

}
</script>
<style type="text/css">
.coco {
    min-height: 60px;
    padding-top: 8px;
}
</style>